
import { defineComponent, PropType } from 'vue'
import { iDomain } from '../../CalendarManagement'
import { formatDate } from '@/helpers/commons/localeHelper'
import moment from 'moment'
import calendarManagementDetailTableDescriptor from './CalendarManagementDetailTableDescriptor.json'
import Checkbox from 'primevue/checkbox'
import Column from 'primevue/column'
import DataTable from 'primevue/datatable'
import MultiSelect from 'primevue/multiselect'

export default defineComponent({
    name: 'calendar-management-detail-table',
    components: { Checkbox, Column, DataTable, MultiSelect },
    props: { propCalendarInfo: { type: Array as PropType<any[]> }, domains: { type: Array as PropType<iDomain[]> } },
    data() {
        return {
            calendarManagementDetailTableDescriptor,
            calendarSplitData: [] as any[]
        }
    },
    computed: {
        canManageCalendar(): boolean {
            return (this.$store.state as any).user.functionalities.includes('ManageCalendar')
        }
    },
    watch: {
        propCalendarInfo() {
            this.loadCalendarInfo()
        }
    },
    created() {
        this.loadCalendarInfo()
    },
    methods: {
        loadCalendarInfo() {
            this.calendarSplitData = this.propCalendarInfo as any[]
        },
        getFormattedDate(date: number) {
            const tempDate = moment(date).format('DD/MM/YYYY')
            return formatDate(tempDate, '', 'DD/MM/YYYY')
        },
        deleteItemConfirm(item: any) {
            this.$confirm.require({
                message: this.$t('common.toast.deleteMessage'),
                header: this.$t('common.toast.deleteConfirmTitle'),
                icon: 'pi pi-exclamation-triangle',
                accept: () => this.deleteItem(item)
            })
        },
        deleteItem(item: any) {
            const index = this.calendarSplitData.findIndex((tempItem: any) => item.idCalComposition === tempItem.idCalComposition)
            if (index !== -1) this.calendarSplitData.splice(index, 1)
        }
    }
})
